// extracted by mini-css-extract-plugin
module.exports = {"keyfact":"ra-keyfact-without-icon_keyfact__d1wK8","keyfact--row":"ra-keyfact-without-icon_keyfact--row__Tz2hi"};